var map = {
	"./arrow_down.svg": "c32b",
	"./arrow_left.svg": "4db9",
	"./arrow_right.svg": "d973",
	"./arrow_up.svg": "d806",
	"./barcode.svg": "f5ac",
	"./book.svg": "6ac0",
	"./chat.svg": "22b2",
	"./close.svg": "7710",
	"./delete.svg": "59a1",
	"./edit.svg": "aa46",
	"./eraser.svg": "995d",
	"./file.svg": "b8b2",
	"./file_check.svg": "8a5a",
	"./folder_check.svg": "03e7",
	"./idcard.svg": "b4d8",
	"./like.svg": "c814",
	"./mail.svg": "26f5",
	"./map_pin.svg": "ab4b",
	"./search.svg": "8e8d",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";